import {
  SavedPaymentMethod,
  PaymentModal,
  EmptyResult,
  ConfirmModal,
} from "../components";
import { useEffect, useState } from "react";
import { Layout } from "../layouts";
import { CustomerCardModel } from "../models";
import { useAuth, useStore } from "../hooks";
import { DeleteSavedPayment, GetSavedPayments } from "../services";
import Skeleton from "react-loading-skeleton";
import { isEmpty } from "../helpers";
import { Toast } from "../components/Toast";

const PaymentPage = () => {
  const { storeId } = useStore();
  const { isLoggedIn, isGuest, customerId } = useAuth();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [payments, setPayments] = useState<CustomerCardModel[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<CustomerCardModel>();

  useEffect(() => {
    if (isLoggedIn && !isGuest) fetchData();
  }, [isLoggedIn, isGuest]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const { status, message, data } = await GetSavedPayments({
        store_id: storeId,
        customer_id: customerId,
      });
      if (status) setPayments(data);
      else Toast.error(message);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDelete = (index: number) => {
    setShowConfirmModal(true);
    setSelectedPayment(payments[index]);
  };

  const handleDelete = async (payment: CustomerCardModel) => {
    setShowConfirmModal(false);

    try {
      setIsLoading(true);
      const { status, message } = await DeleteSavedPayment({
        store_id: storeId,
        customer_id: customerId,
        payment: payment,
      });
      if (status) {
        setPayments((prev) =>
          prev.filter((p) => p.token_uid !== payment.token_uid),
        );
        Toast.success(message);
      } else Toast.error(message);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout showLoader={isLoading}>
      <div className="choose_payment_method_main Profile_sec">
        <div className="payment_header d-flex justify-content-between align-items-start button_meel_bottom mb-3">
          <div>
            <h2 className="page-heading mb-1">Payment Methods</h2>
            <p className="mb-0 page-desc">Manage your saved payment methods.</p>
          </div>

          {/* <button
            className="button"
            onClick={() => setShowPaymentModal(true)}
          >
            + Add Payment Method
          </button> */}
        </div>

        {isLoading && isEmpty(payments) && (
          <Skeleton count={2} height={80} className="mb-3" />
        )}

        {!isLoading && isEmpty(payments) && (
          <EmptyResult message="No Payment Method found" />
        )}

        {payments.map((payment, index) => (
          <SavedPaymentMethod
            key={index}
            payment={payment}
            onDelete={() => onDelete(index)}
          />
        ))}

        <div className="payment_security mb-3">
          🔒 Your payment information is secure and encrypted.
        </div>

        {/* <button onClick={() => setShowPaymentModal(true)} className="addnew_btn addnew_btn1">Add New</button>  */}
      </div>

      <PaymentModal
        show={showPaymentModal}
        handleClose={() => setShowPaymentModal(false)}
      />

      {selectedPayment && (
        <ConfirmModal
          variant="warning"
          title="Are you sure?"
          content={
            <span>
              It will permanent delete card{" "}
              <b>{selectedPayment.masked_number}</b>. You can add this card
              again later.
            </span>
          }
          show={showConfirmModal}
          handleClose={() => setShowConfirmModal(false)}
          handleSubmit={() => handleDelete(selectedPayment)}
        />
      )}
    </Layout>
  );
};

export default PaymentPage;
